import gql from 'graphql-tag';

export const deletePlayerMutation = gql`
  mutation deletePlayer($id: Float!) {
    deletePlayer(id: $id)
  }
`;
